var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 47,
    viewBox: "0 0 239 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_27715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3086 1.46055L2.13754 21.5479C1.05311 22.6278 1.05311 24.3721 2.13754 25.452L22.3086 45.5393C23.3931 46.6193 25.1446 46.6193 26.229 45.5393L34.6865 37.117C35.6577 36.1499 35.6577 34.5818 34.6865 33.6146C33.7153 32.6475 32.1407 32.6475 31.1695 33.6146L24.758 39.9995C24.4881 40.2683 24.0784 40.2683 23.8085 39.9995L7.70045 23.9584C7.43054 23.6896 7.43054 23.2816 7.70045 23.0128L23.8085 6.97166C24.0784 6.70287 24.4881 6.70287 24.758 6.97166L31.1695 13.3566C32.1407 14.3237 33.7153 14.3237 34.6865 13.3566C35.6577 12.3894 35.6577 10.8213 34.6865 9.85419L26.23 1.43277C25.1411 0.376211 23.3889 0.384764 22.3086 1.46055Z",
    fill: "url(#paint0_linear_21_27715)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3086 1.46055L2.13754 21.5479C1.05311 22.6278 1.05311 24.3721 2.13754 25.452L22.3086 45.5393C23.3931 46.6193 25.1446 46.6193 26.229 45.5393L34.6865 37.117C35.6577 36.1499 35.6577 34.5818 34.6865 33.6146C33.7153 32.6475 32.1407 32.6475 31.1695 33.6146L24.758 39.9995C24.4881 40.2683 24.0784 40.2683 23.8085 39.9995L7.70045 23.9584C7.43054 23.6896 7.43054 23.2816 7.70045 23.0128L23.8085 6.97166C24.4806 6.3942 25.5772 5.22457 27.1875 4.95101C28.3842 4.74771 29.6926 5.19517 31.1126 6.2934C30.1632 5.34799 28.5357 3.72777 26.23 1.43277C25.1411 0.376211 23.3889 0.384764 22.3086 1.46055Z",
    fill: "url(#paint1_linear_21_27715)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6386 31.7464C37.6098 32.7136 39.1844 32.7136 40.1555 31.7464L46.3942 25.5337C47.4786 24.4538 47.4786 22.7095 46.3943 21.6297L40.1013 15.385C39.1278 14.419 37.5527 14.4204 36.5809 15.3881C35.6097 16.3553 35.6097 17.9234 36.5809 18.8905L40.8313 23.1232C41.1012 23.392 41.1012 23.8 40.8313 24.0687L36.6386 28.244C35.6674 29.2112 35.6674 30.7793 36.6386 31.7464Z",
    fill: "url(#paint2_linear_21_27715)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3695 29.0239C27.3774 29.0239 29.8157 26.5957 29.8157 23.6003C29.8157 20.605 27.3774 18.1768 24.3695 18.1768C21.3617 18.1768 18.9233 20.605 18.9233 23.6003C18.9233 26.5957 21.3617 29.0239 24.3695 29.0239Z",
    fill: "url(#paint3_linear_21_27715)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.8658 13.898V10.136H83.3458V13.898H76.1848V33.5H72.0268V13.898H64.8658ZM90.415 10.136V33.5H86.257V10.136H90.415ZM95.7056 33.5V10.136H111.183V13.898H99.8636V19.64H110.589V23.402H99.8636V29.738H111.777V33.5H95.7056ZM120.202 33.5H116.044V10.136H124.294C128.782 10.136 132.874 11.72 132.874 16.835C132.874 20.333 130.762 22.709 127.462 23.171L133.666 33.5H128.65L123.238 23.6H120.202V33.5ZM120.202 13.7V20.036H123.634C126.01 20.036 128.518 19.706 128.518 16.802C128.518 14.129 126.109 13.7 123.931 13.7H120.202ZM146.925 33.5V10.136H151.083V19.442H162.006V10.136H166.164V33.5H162.006V23.204H151.083V33.5H146.925ZM171.451 10.136H175.609V24.887C175.609 27.032 176.83 30.134 180.856 30.134C184.882 30.134 186.103 27.032 186.103 24.887V10.136H190.261V25.085C190.261 29.672 187.027 34.094 180.856 34.094C174.652 34.094 171.451 29.639 171.451 25.085V10.136ZM204.111 33.5H195.531V10.136H204.771C207.807 10.136 211.8 11.522 211.8 16.01C211.8 18.419 210.381 20.3 207.741 21.125V21.191C210.744 21.554 212.79 23.93 212.79 26.834C212.79 31.322 209.193 33.5 204.111 33.5ZM199.689 29.936H203.649C206.949 29.936 208.632 28.814 208.632 26.504C208.632 24.128 207.048 23.204 203.88 23.204H199.689V29.936ZM199.689 19.64H203.616C206.124 19.64 207.642 18.485 207.642 16.703C207.642 14.657 206.124 13.7 203.286 13.7H199.689V19.64Z",
    fill: "black",
    fillOpacity: 0.85
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_27715",
    x1: 22.4953,
    y1: 0.646974,
    x2: 41.6289,
    y2: 12.3706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_27715",
    x1: 25.0664,
    y1: 0.646972,
    x2: 15.6597,
    y2: 49.4258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378601,
    stopColor: "#148EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A60FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21_27715",
    x1: 43.7659,
    y1: 12.3507,
    x2: 31.5056,
    y2: 31.5889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA816E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414726,
    stopColor: "#F74A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F51D2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_21_27715",
    x1: 26.3441,
    y1: 14.3053,
    x2: 22.271,
    y2: 30.6528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA8E7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512635,
    stopColor: "#F74A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F51D2C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_27715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.1538,
    height: 46,
    fill: "white",
    transform: "translate(1.17285 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6efc90dbe31201c295cd8e863d847695.svg";
export { ForwardRef as ReactComponent };